import { VariantForm } from "@/components/products/VariantForm";
import { ProductVariant } from "@/types/product-type";
import { ProductVariantUpdateFormValues } from "@/types/product-variant-type";
import { VariantDialogShell } from "./variant-dialog-shell";

interface EditVariantDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  editingVariant: ProductVariant | null;
  productId: string;
  productCode: string;
  onSubmit: (
    data: ProductVariantUpdateFormValues,
  ) => Promise<void>;
  onCancel: () => void;
  isLoading?: boolean;
}

export function EditVariantDialog({
  open,
  onOpenChange,
  editingVariant,
  productId,
  productCode,
  onSubmit,
  onCancel,
  isLoading = false,
}: EditVariantDialogProps) {
  return (
    <VariantDialogShell
      open={open}
      onOpenChange={onOpenChange}
      title="Edit Variant"
      description="Update the variant details and pricing."
      contentClassName="sm:max-w-5xl"
    >
      <VariantForm
        mode="edit"
        productId={productId}
        productCode={productCode}
        editingVariant={editingVariant}
        onSubmit={onSubmit}
        onCancel={onCancel}
        isLoading={isLoading}
      />
    </VariantDialogShell>
  );
}
